import { useTranslation } from 'react-i18next'
import { formatDayTime } from '@dorixona/utils'
import { Icon, type IconName } from '../../ui/Icon'
import type { Transaction } from './api'
import { ledgerText, transactionIcon } from './model'
import { usePoints } from '../../ui/points'

export interface TransactionRowsProps {
  transactions: Transaction[]
}

/** Строки движения баллов. Пустой список — забота экрана: он знает, что сказать. */
export function TransactionRows({ transactions }: TransactionRowsProps) {
  const { t } = useTranslation('account')
  const { formatPoints } = usePoints()

  return (
    <div>
      {transactions.map((transaction) => (
        <div key={transaction.id} className="tx">
          <div className={transaction.amount > 0 ? 'ic gold' : 'ic'}>
            <Icon name={transactionIcon(transaction.type) as IconName} size={19} />
          </div>
          <div>
            <div className="t1">{ledgerText(transaction.type, t)}</div>
            <div className="t2 num">{formatDayTime(transaction.at)}</div>
          </div>
          <div className={transaction.amount >= 0 ? 'amt num plus' : 'amt num'}>
            {transaction.amount >= 0 ? '+' : '−'}
            {formatPoints(Math.abs(transaction.amount))}
          </div>
        </div>
      ))}
    </div>
  )
}
